import "~/misc/common";
import DeviceBase from "./device_base";
import { ChartTemperature } from "./chart_temperature";
import { GaugeTemperature } from "./gauge_temperature";

export default class extends DeviceBase {
  connect() {
    const controller = this;
    this.connectBase({
      channel: "ThermostatChannel",
      onConnection: (connected) => {
        if (connected) controller.sendCmd('?');
      },
      onEvent: (msg: string) => {
        if (msg.startsWith('temp.')) {
          temperature(msg.replace('temp.', ''));
        }
        if (msg.startsWith('selected_thermometer_id=')) {
          $('#state_selected_thermometer_id').val(msg.replace('selected_thermometer_id=', '')).trigger('change.select2');
        }
        if (msg.startsWith('required_temperature=')) {
          required_temperature = parseInt(msg.replace('required_temperature=', '')) / 10.0;
          $('#state_required_temperature').val(required_temperature);
          refreshGauges();
        }
        if (msg.startsWith('hysteresis=')) {
          hysteresis = parseInt(msg.replace('hysteresis=', '')) / 10.0;
          refreshGauges();
        }
        if (msg.startsWith('heating=')) {
          heating(msg.replace('heating=', ''));
        }
        if (msg.startsWith('heating_enabled=')) {
          heating_enabled(msg.replace('heating_enabled=', ''));
        }
      }
    });

    $('#state_heating_enabled').lc_switch('BE', 'KI');
    $('#state_heating').lc_switch('FŰT', 'KI');

    const el = this.element as HTMLDivElement;
    const thermometers = JSON.parse(el.dataset.thermometers!);
    console.log(thermometers);
    let required_temperature = 20.0;
    let hysteresis = 1.0;

    function temperature(msg: string) {
      const parts = msg.split("=");
      const temp = parseFloat(parts[1]) / 10.0;
      const mac = parts[0];
      gauges.updateGauge(mac, temp);
    }

    function heating(msg: string) {
      msg == '1' ? $('#state_heating').lcs_on() : $('#state_heating').lcs_off();
    }

    let disable_lcs_event = false;
    function heating_enabled(msg: string) {
      disable_lcs_event = true;
      msg == '1' ? $('#state_heating_enabled').lcs_on() : $('#state_heating_enabled').lcs_off();
      disable_lcs_event = false;
    }

    $('#state_selected_thermometer_id').on('change', function () {
      controller.sendCmd('selected_thermometer_id=' + $('#state_selected_thermometer_id').val());
    });

    $('#state_required_temperature').on('change', function () {
      const value = $('#state_required_temperature').myGetNumValue();
      if (value) {
        controller.sendCmd('required_temperature=' + Math.round(value * 10.0));
      }
    });

    $('#state_heating_enabled').on('lcs-statuschange', function () {
      if (!disable_lcs_event) {
        controller.sendCmd('heating_enabled=' + (($(this).is(':checked')) ? '1' : '0'));
      }
    });

    const tempStep = 0.5;
    $('#changeTempMinus').click(function () {
      $(this).blur();
      changeTemp(-tempStep);
    });

    $('#changeTempPlus').click(function () {
      $(this).blur();
      changeTemp(tempStep);
    });

    function changeTemp(value: number) {
      const current = $('#state_required_temperature').myGetNumValue();
      if (current) {
        controller.sendCmd('required_temperature=' + Math.round((current + value) * 10.0));
      }
    }

    // TEMPERATURE GAUGE
    const gauges = new GaugeTemperature(thermometers);
    refreshGauges();

    function refreshGauges() {
      gauges.options.yellowFrom = required_temperature - hysteresis;
      gauges.options.yellowTo = required_temperature;
      gauges.options.redFrom = required_temperature;
    }

    //LINE CHART
    const chart = new ChartTemperature('#line', controller.mac_address);

  }
}